/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Collapse } from 'antd'
import _, { isEmpty, isObject, nth, split } from 'lodash'
import {
  checkUrl,
  isCustomProfileImg,
  showToast,
  TOAST_TYPE,
  makeItemImageUrl,
} from '@utils/utils'
import { Schema$Message } from '@v2/protocol/message'
import { MESSAGE_TYPE } from 'adv-protocol/src/GameCommon'
import useRootStore from '@store/useRootStore'
import globalStore from '@store/globalStore'
// image
import AdvProfileImg from '@assets/images/icon/adv-profile.png'
import clubEmblemAlternateImg from '@assets/images/icon/logo-shield-gray-club.png'
import { DownloadIco, ItemBoxIco, PickSolidIco, SharedBetIco } from '@shared/Icon/MessageIcon'
// css
import { SpanButton, Button } from '@styles/button.style'
import { ImageWrap, LinkWrap, UploadMessageImgStyle } from '@views/Popup/MessageContentPopup/index.style'
import { MESSAGE_IMAGE_BASE_URL, MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY } from '@constants/index'
import { AccordionWrapper, ItemWrapBtnStyle, MessageBody } from '../index.style'
import MessageListItemFooter from './MessageListItemFooter'
import { COMMUNICATION_BLOCK_TYPE } from '@v2/constants/common'
import dayjs from 'dayjs'
import AdvImg from '@components/AdvImg'
import MagnifyingGlassIco from '@shared/Icon/EtcIcon/MagnifyingGlassIco'

interface MessageListItemProps {
  index: MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY
  track: Schema$Message
  messageType?: string
  onDelete: (arg: string) => void
  onReceiveItem: (arg: string) => void
  onReadMessage: (arg: string) => void
  onSaveBettingHistoryShare: (arg: string) => void
  onUserBlockSuccessHandler: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
}

const MessageListItem: React.FC<MessageListItemProps> = (props: MessageListItemProps) => {
  const { pickStore } = useRootStore()
  const { index, track,
    onDelete, onReceiveItem, onReadMessage,
    messageType, onSaveBettingHistoryShare, onUserBlockSuccessHandler } = props
  const { pick } = track
  const days = ['일', '월', '화', '수', '목', '금', '토']
  const now = dayjs().valueOf()
  const hasAttachedUrl = track.attachedUrl?.length > 0
  const hasAttachedImage = track.attachedImage?.length >0

  let betEnd
  let messageContent = ''

  const applyDefaultEmblem = e => {
    e.target.src = clubEmblemAlternateImg
  }

  if (isObject(pick)) {
    betEnd = dayjs(pick.dateBettingEnd).valueOf()
  }

  const isSystemMessage = () => {
    return track.type === MESSAGE_TYPE.SYSTEM
      || track.type === MESSAGE_TYPE.REWARD || (track.type === MESSAGE_TYPE.NORMAL && isEmpty(track.senderId))
  }

  const isClubMessage = () => {
    return track.type === MESSAGE_TYPE.CLUB_TO_MEMBER || track.type === MESSAGE_TYPE.CLUB_TO_ALL_MEMBER
  }

  const isHiddenContent = () => {
    return track.type === MESSAGE_TYPE.PICK_ADD || track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE
  }

  // 픽 팝업
  // const [visiblePick, setVisiblePick] = useState(false)
  const onShowPickModal = () => {
    // setVisiblePick(true)
    if (isObject(track.pickPurchase)) {
      showToast(TOAST_TYPE.INFO, '이미 구매한 픽입니다.')
    } else {
      pickStore.setPurchasePick(pick, true)
    }
  }

  const setContent = () => {
    let content = track.content

    if (isHiddenContent()) {
      content = ''
    }

    messageContent = content
  }

  const getDateFormat = (date: Date): string => {
    const d = dayjs(date)
    const f = [d.format('MM/DD'), '(', nth(days, d.day()), ') ', d.format('HH:mm')]
    return f.join('')
  }

  const onReceiveHandler = async () => {
    switch (track.type) {
      case MESSAGE_TYPE.SYSTEM:
      case MESSAGE_TYPE.NORMAL:
      case MESSAGE_TYPE.GIFT:
      case MESSAGE_TYPE.REWARD:
        onReceiveItem(track.id)
        break
      case MESSAGE_TYPE.PICK_ADD: {
        const { sell } = pick
        if (sell === 1 && now < betEnd) {
          onShowPickModal()
        } else {
          showToast(TOAST_TYPE.INFO, '베팅이 마감되거나 공유가 중지된 픽은 구매할 수 없습니다.')
        }
      }
        break
      case MESSAGE_TYPE.BETTING_HISTORY_SHARE:
        onSaveBettingHistoryShare(track.id)
        break
    }
  }

  const onClickHeaderIcon = e => {
    e.stopPropagation()
    if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE) {
      onReceiveHandler()
    }
  }

  const makePreviewContent = (content: string): string => {
    if (isEmpty(content)) {
      return ''
    }

    let value = content

    const contentToArray = split(content, '\n')

    if (contentToArray.length > 0) {
      const firstLine = contentToArray[0]

      value = firstLine
    }

    return value
  }

  let typeIcon = null
  let iconWrapButton = null

  if (track) {
    setContent()

    switch (track.type) {
      case MESSAGE_TYPE.SYSTEM:
      case MESSAGE_TYPE.NORMAL:
      case MESSAGE_TYPE.GIFT:
      case MESSAGE_TYPE.REWARD:
      case MESSAGE_TYPE.BETTING_HISTORY_SHARE:
        if (track.itemCode > 0 || track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE) {
          if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE) {
            // const saveText = track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE ? '저장' : '받기'
            // const savedText = track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE ? '저장완료' : '수령완료'
            typeIcon = (

              <div className="attached-item">
                <ItemBoxIco isGray={true}/>
                <span className="item-img">
                  {track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE ?
                    <SharedBetIco/>
                    :
                    <img key="itemImage" src={makeItemImageUrl(track.item)} alt="첨부된 아이템"/>
                  }
                </span>

                <span className="download-icon"><DownloadIco/></span>
              </div>

              // <ItemStyle className="item-style">
              //   <img key="itemImage" src={track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE ? makeBettingHistoryShareImageUrl() : makeItemImageUrl(track.item)} alt="프로필"/>
              // </ItemStyle>
              // <ItemName className="item-text">{saveText}</ItemName>
              // <img key="received" src={ReceivedIco} alt={savedText} css={ReceivedStyle} className="received-icon" />
            )
          } else if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.SENT) {
            typeIcon = (

              <div className="attached-item sent-message">
                <span className="item-img">
                  {track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE ?
                    <SharedBetIco/>
                    :
                    <img key="itemImage" src={makeItemImageUrl(track.item)} alt="첨부된 아이템"/>
                  }
                </span>
              </div>

              // <ItemStyle className="item-style only-img">
              //   <img key="itemImage" src={track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE ? makeBettingHistoryShareImageUrl() : makeItemImageUrl(track.item)} alt="프로필"/>
              // </ItemStyle>
            )
          }
          iconWrapButton = <Button css={ItemWrapBtnStyle} onClick={onClickHeaderIcon}>{typeIcon}</Button>
        }
        break
      case MESSAGE_TYPE.PICK_ADD: {
        const { sell } = pick
        if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE) {
          let itemElem = null
          if (sell === 1 && now < betEnd) {
            itemElem = <Fragment/>
          } else {
            itemElem = <span className="end-pick"/>
          }
          typeIcon = (
            <div className="attached-item">
              <ItemBoxIco/>
              <span className="item-img pick-item">
                <PickSolidIco/>

                {/* *********** 공유된 베팅 내역일 경우 ************ */}
                {/*<SharedBetIco/>*/}
              </span>
              {itemElem}
            </div>
          )
        } else if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.SENT) {
          typeIcon = (
            <div className="attached-item sent-message">
              <span className="item-img">
                <PickSolidIco/>

                {/* *********** 공유된 베팅 내역일 경우 ************ */}
                {/*<SharedBetIco/>*/}
              </span>
            </div>
          )
        }
        iconWrapButton = <Button css={ItemWrapBtnStyle} onClick={onClickHeaderIcon} className="header-item-btn">{typeIcon}</Button>
      }
        break
    }
  }

  const className = []
  if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE) {
    if (track.receiverRead === 1) {
      className.push('read')
    }
    if (track.receivedItem === 1) {
      className.push('received')
    }
    if (track.type === MESSAGE_TYPE.PICK_ADD && isObject(track.pickPurchase)) {
      className.push('received')
    }
    if ((track.type === MESSAGE_TYPE.PICK_ADD && track.pick.sell === 0) || now > betEnd) {
      className.push('end')
    }
  } else if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.SENT) {
    className.push('sent-message-list')
    if (track.receiverRead === 1) {
      className.push('read sent-message-list')
    }
  }

  const onChangeMessageItemListHeader = () => {
    if (index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE) {
      onReadMessage(track.id)
    }
  }

  const onClickAttachedUrl = () => {
    const { attachedUrl } = track

    if (!checkUrl(attachedUrl)) {
      showToast(TOAST_TYPE.INFO, '올바른 URL 링크가 아닙니다.')
      return
    }
    globalStore.toMoveWebHomePage(attachedUrl, 'popup')
  }

  const onClickViewImg = () => {
    const imageSrc = `${MESSAGE_IMAGE_BASE_URL}${track.attachedImage}`
    globalStore.addGeneralPopupProperties(
      <div css={UploadMessageImgStyle}>
        <img src={imageSrc} alt="메시지 첨부 이미지"/>
      </div>
      , '공유 이미지', { wrapClassName: '', className: '', isScroll: true, custom: false, clsBtn: false })
  }

  const isPreviewContent = !_.isEmpty(makePreviewContent(messageContent))

  return (
    <Fragment>
      <AccordionWrapper>
        <Collapse onChange={onChangeMessageItemListHeader}>
          <Collapse.Panel
            id={track.id}
            key={track.id}
            showArrow={false}
            className={className.join(' ')}
            header={
              <Fragment>
                <div className="ant-collapse-header-top">
                  <div className="sender-profile">

                    {/* TODO 시스템 메시지일 경우 className 'system'을 추가해야합니다. */}
                    {/* 시스템 메시지 */
                      (isSystemMessage()) && (
                        <img src={AdvProfileImg} alt="승부사온라인 프로필" className="sender-profile--img system"/>)
                    }
                    {/* 클럽 엠블럼 이미지 */
                      (!isSystemMessage()) && (isClubMessage()) &&
                      (<img src={track.senderProfileImg} onError={applyDefaultEmblem} alt="클럽 엠블렘"
                            className="sender-profile--img"/>)
                    }
                    {/* 일반 유저 메시지 */
                      /* TODO 유저 프로필에서 커스텀 프로필을 설정했을 때와 안했을 때를 나눴습니다. */
                      (!isSystemMessage() && !isClubMessage())
                      && ((isCustomProfileImg(track.senderProfileImg)) ?
                          (<AdvImg src={track.senderProfileImg} srcMode={'small'} alt="유저 프로필"
                                   className="sender-profile--img custom-img"/>)
                          :
                          (<AdvImg src={track.senderProfileImg} srcMode={'small'} alt="기본 스킨"
                                   className="sender-profile--img"/>)
                      )
                    }
                    {/*<img src={AdvProfileDummyImg} alt="유저 프로필" className="sender-profile--img"/>*/}

                  </div>
                  <span className="new-message-badge"/>

                  <div className="message-info">
                    <div className="sender-info">
                      {/*{MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE ? <span>보낸 {whoReceive}</span> : <span>받는 {whoReceive}</span>}*/}
                      <p className="sender">
                        {index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.RECEIVE ? track.senderNick : track.receiverNick}
                        {index === MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY.SENT && (
                          <span className={`status ${className.join(' ')}`}>
                            <span className="not-read txt">읽지않음</span>
                            <span className="read txt">읽음</span>
                          </span>
                        )}
                      </p>

                      <div className="date">
                        {getDateFormat(track.createdAt)}
                        <span className="term">
                          {`${dayjs(track.dateExpire).diff(dayjs(), 'days')}일 뒤 삭제`}</span>
                      </div>
                    </div>
                    <div className="message-item">
                      {iconWrapButton}
                    </div>
                  </div>
                </div>

                <div
                  className={isPreviewContent ? 'message-summary' : 'message-summary is-preview-empty'}
                >
                  {isPreviewContent &&
                    <p
                      className="message-summary-txt"
                      dangerouslySetInnerHTML={isPreviewContent ? { __html: makePreviewContent(messageContent) } : null}
                    />
                  }
                </div>

                {/*<DateSpan className="header-txt" style={{ margin: '0 0 2px' }}>*/}
                {/*  {getDateFormat(track.createdAt)}*/}
                {/*</DateSpan>*/}
                {/*{Arrow}*/}
                {/* 상황별로 부모의 className만 변경되면 됩니다. */}
                {/* 읽지 않음: className="status" / 읽음: className="status read"  */}

                {/*<MessageTitle css={TxtLimit} className="header-txt">*/}
                {/*  {track.title}*/}
                {/*</MessageTitle>*/}

              </Fragment>
            }
          >
            {track.type === MESSAGE_TYPE.PICK_ADD || track.type === MESSAGE_TYPE.BETTING_HISTORY_SHARE
              ? null : <MessageBody dangerouslySetInnerHTML={{ __html: messageContent }} />}

            {hasAttachedImage && (
              <ImageWrap className={isSystemMessage() && 'system-message'}>
                <Button TP className="img-wrapper" onClick={() => onClickViewImg()}>
                  <AdvImg src={`${MESSAGE_IMAGE_BASE_URL}${track.attachedImage}`}
                          srcMode={isSystemMessage() ? null : 'small'} alt="업로드된 이미지"/>
                  <span className="zoom-ico">
                    <MagnifyingGlassIco/>
                  </span>
                </Button>
              </ImageWrap>
            )}

            {(hasAttachedUrl) && (
              <LinkWrap className="message-popup">
                <SpanButton onClick={onClickAttachedUrl} className="attached-link">{track.attachedUrl}</SpanButton>
              </LinkWrap>
            )}
            <MessageListItemFooter
              index={index}
              track={track}
              onDelete={onDelete}
              messageType={messageType}
              onReceiveHandler={onReceiveHandler}
              onShowPick={onShowPickModal}
              onUserBlockSuccessHandler={onUserBlockSuccessHandler}
            />
          </Collapse.Panel>
        </Collapse>
      </AccordionWrapper>

      {/* 픽 구매 팝업 */}
      {/* <PickPurchase key={`${track.id}_pick`} visible={visiblePick} setVisible={setVisiblePick} /> */}
    </Fragment>
  )
}
export default MessageListItem
